// extracted by mini-css-extract-plugin
export var completionBody = "_fm-2";
export var completionCard = "_fm-0";
export var completionFooter = "_fm-3";
export var completionTitle = "_fm-1";